import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { requestResizeAnimation } from '../util/request-animation';
import { lenis } from '../util/lenis';

// register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

const checkTabScroller = (tabGroup) => {
  const tabScroller = tabGroup.querySelector('.tab-component_scroller');
  const tabList = tabGroup.querySelector('.tab-component_list');

  // make sure we start at the beginning
  tabScroller.scrollLeft = 0;

  if(tabGroup.offsetWidth >= tabList.offsetWidth) {
    tabGroup.classList.remove('scroller');
  } else {
    tabGroup.classList.add('scroller');
  }
};

// tab components
const initTabs = () => {
  document.querySelectorAll('[data-tab-component-group]').forEach(tabGroup => {
    tabGroup.querySelectorAll('.tab-component').forEach((tab, index) => {
      tab.addEventListener('click', function() {
        if(tab.classList.contains('tab-component--active')) {
          return;
        }

        document.querySelectorAll('.tab-component--active').forEach((activeTab) => {
          activeTab.classList.remove('tab-component--active');
        });

        document.querySelectorAll('.tab-content--active').forEach((activeTabContent) => {
          activeTabContent.classList.remove('tab-content--active');
        });

        let tabContent = document.getElementById(tab.getAttribute('aria-controls'));

        if(tabContent !== null) {
          tab.classList.add('tab-component--active');
          tabContent.classList.add('tab-content--active');

          let tabVideo = tabContent.querySelector('video');
          if(tabVideo !== null) {
            tabVideo.addEventListener('play', () => {
              tabVideo.classList.add('playing');
            })

            tabVideo.play();

            gsap.from(tabVideo, {
              autoAlpha: 0,
              duration: 0.5
            });
          }
        }

        if(lenis) {
          lenis.resize();
        }
      });

      if(index === 0) {
        let tabContent = document.getElementById(tab.getAttribute('aria-controls'));
        if(tabContent !== null) {
          tab.classList.add('tab-component--active');
          tabContent.classList.add('tab-content--active');
        }

        //tab.click();
      }
    });

    let firstTabContent = tabGroup.querySelector('.tab-content--active');
    if(firstTabContent !== null) {
      let firstVideo = firstTabContent.querySelector('video');

      if(firstVideo !== null) {
        firstVideo.addEventListener('play', () => {
          firstVideo.classList.add('playing');
        });
        firstVideo.play();

        ScrollTrigger.create({
          trigger: firstTabContent,
          start: 'top bottom',
          once: true,
          onEnter: function() {
            firstVideo.currentTime = 0;
          }
        });

        ScrollTrigger.create({
          trigger: firstTabContent,
          start: 'top center',
          once: true,
          onEnter: function() {
            firstVideo.play();
          }
        });
      }
    }

    checkTabScroller(tabGroup);
    requestResizeAnimation(() => {
      checkTabScroller(tabGroup);
    });

    let scrollInterval;
    const tabScroller = tabGroup.querySelector('.tab-component_scroller');

    const startScrollLeft = function() {
      console.log('startScrollLeft');
      scrollInterval = setInterval(function() {
        tabScroller.scrollLeft -= 5;
      }, 10);
    };

    const startScrollRight = function() {
      console.log('startScrollRight');
      scrollInterval = setInterval(function() {
        tabScroller.scrollLeft += 5;
      }, 10);
    };

    const stopScroll = function() {
      console.log('stopScroll');
      clearInterval(scrollInterval);
    };

    const tabScrollerBtnLeft = tabGroup.querySelector('.tab-component_scroller-arrow-left');

    tabScrollerBtnLeft.addEventListener('mousedown', startScrollLeft);
    tabScrollerBtnLeft.addEventListener('mouseup', stopScroll);
    tabScrollerBtnLeft.addEventListener('mouseleave', startScrollLeft);
    tabScrollerBtnLeft.addEventListener('touchstart', function(e) {
      e.preventDefault();
      startScrollLeft();
    });
    tabScrollerBtnLeft.addEventListener('touchend', stopScroll);

    const tabScrollerBtnRight = tabGroup.querySelector('.tab-component_scroller-arrow-right');

    tabScrollerBtnRight.addEventListener('mousedown', startScrollRight);
    tabScrollerBtnRight.addEventListener('mouseup', stopScroll);
    tabScrollerBtnRight.addEventListener('mouseleave', startScrollRight);
    tabScrollerBtnRight.addEventListener('touchstart', function(e) {
      e.preventDefault();
      startScrollRight();
    });
    tabScrollerBtnRight.addEventListener('touchend', stopScroll);

  });
};

export { initTabs };